import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { CheckboxToggle } from 'cstar-react-primitives/lib/redux-form/microFields/CheckboxToggle';

import senderFieldMessages from './senderFieldMessages';
import { setSenderOptin } from './senderModule';
import { getSenderOptIn } from './senderSelectors';

export const SenderOptInField = ({
    optInValue,
    setOptin,
    cashbotName,
    intl
}) => {
    const emailOptInProps = {
        label: intl.formatMessage(senderFieldMessages.emailOptIn),
        cashbotName,
        input: {
            onChange: setOptin,
            value: optInValue,
            name: 'senderOptIn'
        }
    };
    return <CheckboxToggle {...emailOptInProps} />;
};

SenderOptInField.defaultProps = {
    optInValue: false
};

SenderOptInField.propTypes = {
    cashbotName: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    optInValue: PropTypes.bool,
    setOptin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    optInValue: getSenderOptIn(state)
});

const mapDispatchToProps = {
    setOptin: setSenderOptin
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SenderOptInField));
